import _ from 'lodash'
import Table from './table'
import Relation from './relation'

export const relationTypes = {
  ONE2ONE: 'OneToOne',
  ONE2MANY: 'OneToMany',
  MANY2ONE: 'ManyToOne'
}

export default class Schmea {
  // TODO root
  tables = []
  relations = []

  load (model) {
    this.tables = model.tables.map(m => Table.load(m))
    if (model.relations) {
      this.relations = model.relations.map(m => Relation.load(m))
    }
  }

  getTable (tableId) {
    return this.tables.find(m => m.tableId === tableId)
  }

  createTable (id, name) {
    const table = Table.create({id, name})
    this.tables.unshift(table)
  }

  loadTable (table) {
    this.tables.unshift(table)
  }

  needCreateTable ({tableId}) {
    return !this.tables.some(m => m.tableId === tableId)
  }

  createRelation (args) {
    const relation = new Relation(args)
    this.relations.push(relation)
    return relation
  }

  removeTable (table) {
    const pos = this.tables.indexOf(table)
    this.tables.splice(pos, 1)

    this.relations
      .filter(m => m.primaryTable === table.tableId || m.foreignTable === table.tableId)
      .forEach(n => {
        this.removeRelation(n)
      })
  }

  removeRelation (relation) {
    const pos = this.relations.indexOf(relation)
    this.relations.splice(pos, 1)
  }

  // 依据列 id 获取当前列所在的表
  getTableByColumnId (columnId) {
    return this.tables.find(m => {
      if (m.columns.find(n => n.id === columnId)) {
        return m
      }
    })
  }

  // 依据表 id 获取所有和当前表有关系的表信息
  getRelationTable (relationId, tableId) {
    let oneToOneTables = []
    let oneToManyTables = []
    // 父 relations 信息
    let parentRelations = this.getParentRelationByTableId(tableId)
    if (parentRelations.length === 0) {
      // 如果没有找到任何父元素的关联, 表明当前表是主表
      oneToOneTables.push(this.tables.find(m => m.tableId === tableId))
    }
    let parentRelationIds = []
    parentRelations.forEach(m => {
      parentRelationIds.push(m.id)
      let table = _.cloneDeep(this.tables.find(n => n.tableId === m.primaryTable))
      oneToOneTables.push(table)
    })
    if (relationId) {
      let currentRelation = this.relations.find(m => m.id === relationId)
      let table = _.cloneDeep(this.tables.find(m => m.tableId === currentRelation.foreignTable))
      table.relationId = relationId
      oneToOneTables.push(table)
      parentRelationIds.push(relationId)
    }
    // XXX: 完整的处理方案应该是查询所有的属于当前表的上级表, 所有当前表的下级表, 以及没有任何关系的表, 上级表属于一对一的关系, 下级表和无关系的表属于一对多的表.
    // XXX: 此处为了简化操作, 只查询了主表信息, 然后过滤, 其他的全部作为一对多的关系, 完整方法放在 backup 方法中
    let childrenRelations = this.relations.filter(m => !parentRelationIds.includes(m.id))
    childrenRelations.forEach(m => {
      let table = _.cloneDeep(this.tables.find(n => n.tableId === m.foreignTable))
      table.relationId = m.id
      oneToManyTables.push(table)
    })
    return {oneToOneTables, oneToManyTables}
  }

  // 依据表 id 获取当前表的所有上级表的信息(需要一直查询)
  getParentRelationByTableId (tableId) {
    let relationIds = []
    let relation = this.relations.filter(m => m.foreignTable === tableId)
    if (relation) {
      relation.forEach(m => {
        relationIds.push(m)
        relationIds = _.concat(relationIds, this.getParentRelationByTableId(m.primaryTable))
      })
    }
    return relationIds
  }

  // 依据表 id 获取当前表的子表信息(只查询字表信息, 不进行深度查询了)
  getChildrenRelationByTableId (tableId) {
    let relationIds = []
    let relation = this.relations.filter(m => m.primaryTable === tableId)
    if (relation) {
      relation.forEach(m => {
        relationIds.push(m)
        relationIds = _.concat(relationIds, this.getChildrenRelationByTableId(m.foreignTable))
      })
    }
    return relationIds
  }

  backup (relations, tableId) {
    let oneToOneTables = []
    let oneToManyTables = []
    let parentRelations = this.getParentRelationByTableId(tableId)
    let childrenRelations = this.getChildrenRelationByTableId(tableId)
    parentRelations.forEach(m => {
      let table = this.tables.find(n => n.tableId === m.primaryTable)
      table.relationId = m.id
      oneToOneTables.push(table)
    })
    childrenRelations.forEach(m => {
      let table = this.tables.find(n => n.tableId === m.foreignTable)
      table.relationId = m.id
      oneToManyTables.push(table)
    })
    let useRelationId = _.concat(parentRelations, childrenRelations)
    let unuesRelations = this.relations.filter(m => !useRelationId.includes(m.id))
    unuesRelations.forEach(m => {
      let table = this.tables.find(n => n.tableId === m.foreignTable)
      table.relationId = m.id
      oneToManyTables.push(table)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/form/schema.js